import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// Config
import colors from "../../config/colors";

// Components
import GetConnectedHero from "./GetConnectedHero";
import GetConnectedImplementation from "./GetConnectedImplementation";
import GetConnectedPolicing from "./GetConnectedPolicing";
import HowItWorksMini from "./HowItWorksMini";
import GetConnectedVerifiableEvidence from "./GetConnectedVerifiableEvidence";
import GetConnectedFormSection from "./GetConnectedFormSection";
import AccreditationSection from "../HomePage/AccreditationSection";
import Section from "../../components/Section/Section";

const useStyles = makeStyles(theme => ({
  sectionCross: {
    paddingTop: 0,
    backgroundColor: colors.lightGrey,
    [theme.breakpoints.down("xs")]: {
      marginTop: 0
    }
  }
}));

const ContactSupport = () => {
  const classes = useStyles();

  return (
    <main>
      <GetConnectedHero />
      <GetConnectedPolicing />
      <GetConnectedImplementation />
      <HowItWorksMini />
      <GetConnectedVerifiableEvidence />
      <GetConnectedFormSection />
      <Section className={classes.sectionCross}>
        <AccreditationSection />
      </Section>
    </main>
  );
};

export default ContactSupport;
